import {BMService} from '@/common/api/bm.service'
import {
    BM_CREATE,
    BM_EDIT,
    BM_DELETE,
    BM_GET,
    BMS_GET,
    BM_SEARCH,
    BM_DAYS_OFF_GET,
    BM_ACTIVE,
    BM_INACTIVE,
    BM_ADD_SERVICE,
    BM_UPDATE_SERVICE,
    BM_ADD_DAY_OFF,
    BM_DELETE_DAY_OFF,
    BM_GET_SERVICES,
    BM_DELETE_WORK_DAY,
    BM_UPDATE_WORK_DAY,
    BM_ADD_WORK_DAY,
    BM_GET_WORK_DAYS,
    ASSISTANTS_GET, BM_CASH_FLOW_LIST, BM_ADD_PAYMENT, BM_BALANCE_GET, BM_DELETE_SERVICE
} from './actions/bm.type'
import {
    SET_BM,
    SET_BMS,
    SET_BM_DAYS_OFF,
    SET_BM_IMAGE,
    SET_BM_PAGINATION,
    SET_BM_ACTIVE,
    // BM_ADD_SERVICE,
    BM_REMOVE_SERVICE,
    BM_ADD_WEEKDAY,
    BM_REMOVE_WEEKDAY,
    BM_RESET,
    BM_REMOVE_DAY_OFF,
    SET_BM_DAY_OFF,
    BM_RESET_STATE,
    SET_BM_SERVICES,
    SET_BM_SERVICE,
    BM_RESET_SERVICE,
    SET_BM_WEEKDAYS,
    SET_BM_WORKDAY,
    BM_RESET_WORKDAY,
    SET_ASSISTANTS, SET_BM_CASH_FLOW_PAGINATION, SET_BM_CASH_FLOW, SET_BM_BALANCE
} from './mutations/bm.type'

import {
    CHANGE_PROGRESS
} from './mutations/mutations.type'
import Vue from "vue";

const initialState = () => {
    return {
        bm: {
            id: 0,
            name: "",
            nickname: "",
            cpf: "",
            cnpj: null,
            pixkey: null,
            obs: "",
            desc: "",
            image: "",
            assistant: false,
            balance: null,
            services: [
                {id: 0, duration: null}
            ],
            weekDays: [{id: 0, startTime: null, endTime: null}],
            dayOffs: [{id: 0, startDate: null, endDate: null}],
            commissionService: null,
            commissionProduct: null,
            commissionSupply: null,
            serviceStepTime: 0
        },

        bmService: {
            id: 0,
            duration: null,
            customValue: null,
            commission: null
        },

        bmWorkDay: {
            id: 0,
            weekDayID: 0,
            startTime: null,
            endTime: null
        },
        
        bmPay: {
            value:null,
            accountID:0
        },

        balance: {balanceReleased: null,balanceToRelease: null,moneyBalance: null },
        
        dayOff: {
            id: 0,
            startDate: null,
            endDate: null
        },

        bmPagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },
        bmCashFlowPagination: {
            bmID: 0,
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },


        bms: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },
        bmCashFlow: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },
        assistants: []
    }
}

export const state = initialState()

const getters = {
    bm: state => {
        return state.bm
    },
    bmPay: state =>{
        return state.bmPay
    },
    bms: state => {
        return state.bms
    },
    bmBalance: state =>{
        return state.balance
    },
    bmCashFlow: state => {
        return state.bmCashFlow
    },
    bmPagination: state => {
        return state.bmPagination
    },
    bmCashFlowPagination: state => {
        return state.bmCashFlowPagination
    },
    itemsPerPage: state => {
        return state.itemsPerPage
    },
    bmService: state => {
        return state.bmService
    },
    bmWorkDay: state => {
      return state.bmWorkDay  
    },
    assistants: state => {
      return state.assistants  
    },
    dayOff: state => {
        return state.dayOff
    },
    totalBMS: state => {
        return state.bms.totalItems
    }
}

export const mutations = {
    [SET_BM](state, data) {
        state.bm = data
    },
    [SET_BM_BALANCE](state, data) {
        state.balance = data
    },
    [SET_BMS](state, data) {
        state.bms = data
    },
    [SET_BM_CASH_FLOW](state, data) {
        state.bmCashFlow = data
    },
    [SET_ASSISTANTS](state, data) {
        state.assistants = data
    },
    [SET_BM_DAYS_OFF](state, data) {
        Vue.set(state.bm, 'dayOffs', data)
    },
    [SET_BM_SERVICE](state, data) {
        Object.assign(state.bmService, data)
        // state.bmService = data
    },
    [SET_BM_SERVICES](state, data) {
        state.bm.services = data
    },
    [SET_BM_WORKDAY](state, data) {
        Object.assign(state.bmWorkDay, data)
        // state.bmService = data
    },
    [SET_BM_WEEKDAYS](state, data) {
        state.bm.weekDays = data
    },
    [BM_REMOVE_SERVICE](state, index) {
        state.bm.services.splice(index, 1)
    },

    [BM_ADD_WEEKDAY](state) {
        state.bm.weekDays.push({id: 0, startTime: null, endTime: null})
    },

    [SET_BM_DAY_OFF](state, data) {
        state.dayOff = data
    },
    [BM_REMOVE_DAY_OFF](state, index) {
        state.bm.dayOffs.splice(index, 1)
    },

    [SET_BM_PAGINATION](state, data) {
        state.bms.activePage = data.page
        state.bmPagination.itemsPerPage = data.itemsPerPage
        state.bmPagination.orderBy = data.orderBy
        state.bmPagination.sortDesc = data.sortDesc
    },
    [SET_BM_CASH_FLOW_PAGINATION](state, data) {
        state.bmCashFlowPagination.bmID = data.bmID
        state.bmCashFlow.activePage = data.page
        state.bmCashFlowPagination.itemsPerPage = data.itemsPerPage
        state.bmCashFlowPagination.orderBy = data.orderBy
        state.bmCashFlowPagination.sortDesc = data.sortDesc
    },

    [SET_BM_ACTIVE](state, active) {
        state.bm.active = active
    },
    [BM_REMOVE_WEEKDAY](state, index) {
        state.bm.weekDays.splice(index, 1)
    },
    [SET_BM_IMAGE](state, image) {
        state.bm.image = image
    },
    [BM_RESET](state) {
        Object.assign(state.bm, initialState().bm)
    },
    [BM_RESET_SERVICE](state) {
        Object.assign(state.bmService, initialState().bmService)
    },
    [BM_RESET_WORKDAY](state) {
        Object.assign(state.bmWorkDay, initialState().bmWorkDay)
    },
    [BM_RESET_STATE](state) {
        Object.assign(state, initialState())
    },
}

export const actions = {
    async [BMS_GET]({commit, state}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await BMService.list(state.bms.activePage, state.itemsPerPage)
        commit(SET_BMS, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [ASSISTANTS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await BMService.getAssistants()
        commit(SET_ASSISTANTS, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [BM_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)

        const {data} = await BMService.get(id)
        commit(SET_BM, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [BM_BALANCE_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)

        const {data} = await BMService.getBalance(id)
        commit(SET_BM_BALANCE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [BM_DAYS_OFF_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await BMService.getDayOffs(id)
        commit(SET_BM_DAYS_OFF, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [BM_SEARCH]({commit, state}) {

        // commit(CHANGE_PROGRESS, true)
        const {data} = await BMService.search(
            state.bms.activePage,
            state.bmPagination.itemsPerPage,
            state.bms.active,
            state.bmPagination.search,
            state.bmPagination.orderBy,
            state.bmPagination.sortDesc)
        commit(SET_BMS, data)
        // commit(CHANGE_PROGRESS, false)
    },
    async [BM_CASH_FLOW_LIST]({commit, state}) {

        commit(CHANGE_PROGRESS, true)
        const {data} = await BMService.listCashFlow(
            state.bmCashFlowPagination.bmID,
            state.bmCashFlow.activePage,
            state.bmCashFlowPagination.itemsPerPage,
            state.bmCashFlow.active,
            state.bmCashFlowPagination.search,
            state.bmCashFlowPagination.orderBy,
            state.bmCashFlowPagination.sortDesc)
        commit(SET_BM_CASH_FLOW, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [BM_CREATE]({state}) {

        let bm = {
            name: state.bm.name.toUpperCase(),
            nickname: state.bm.nickname.toUpperCase(),
            cpf: state.bm.cpf,
            cnpj: state.bm.cnpj,
            obs: state.bm.obs.toUpperCase(),
            desc: state.bm.desc.toUpperCase(),
            image: state.bm.image,
            assistant: state.bm.assistant,
            // services: state.bm.services,
            // weekDays: state.bm.weekDays,
            // commissionService: state.bm.commissionService,
            commissionProduct: state.bm.commissionProduct,
            commissionSupply: state.bm.commissionSupply,
            serviceStepTime: state.bm.serviceStepTime

        }
        if (bm.cnpj !== null) {
            if (bm.cnpj === "") {
                bm.cnpj = null
            }
        }
        return BMService.create(bm)
    },
    async [BM_EDIT]({state}) {

        let bm = {
            id: state.bm.id,
            name: state.bm.name.toUpperCase(),
            nickname: state.bm.nickname.toUpperCase(),
            cpf: state.bm.cpf,
            cnpj: state.bm.cnpj,
            pixkey: state.bm.pixkey,
            obs: state.bm.obs.toUpperCase(),
            desc: state.bm.desc.toUpperCase(),
            image: state.bm.image,
            assistant: state.bm.assistant,
            // services: state.bm.services,
            // weekDays: state.bm.weekDays,
            // commissionService: state.bm.commissionService,
            commissionProduct: state.bm.commissionProduct,
            commissionSupply: state.bm.commissionSupply,
            serviceStepTime: state.bm.serviceStepTime
        }
        if (bm.cnpj !== null) {
            if (bm.cnpj === "") {
                bm.cnpj = null
            }
        }
        // const toBase64 = file => new Promise((resolve, reject) => {
        //     const reader = new FileReader();
        //     reader.readAsDataURL(file);
        //     reader.onload = () => resolve(reader.result);
        //     reader.onerror = error => reject(error);
        // });
        // bm.image = await toBase64(state.bm.image)
        return BMService.update("", bm)
    },
    
    async [BM_GET_SERVICES]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await BMService.getServices(id)
        commit(SET_BM_SERVICES, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [BM_ADD_SERVICE]({state}) {
        return BMService.addService(state.bm.id, state.bmService);
    },
    async [BM_ADD_PAYMENT]({state}, id) {
        return BMService.addPayment(id, state.bmPay);
    },
    async [BM_UPDATE_SERVICE]({state}) {
        return BMService.updateService(state.bm.id, state.bmService);
    },
    async [BM_DELETE_SERVICE]({state}) {
        return BMService.deleteService(state.bm.id, state.bmService.id);
    },

    async [BM_GET_WORK_DAYS]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await BMService.getWorkDays(id)
        commit(SET_BM_WEEKDAYS, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [BM_ADD_WORK_DAY]({state}) {
        return BMService.addWorkDay(state.bm.id, state.bmWorkDay);
    },
    async [BM_UPDATE_WORK_DAY]({state}) {
        return BMService.updateWorkDay(state.bm.id, state.bmWorkDay);
    },
    async [BM_DELETE_WORK_DAY]({state}, id) {
        return BMService.deleteWorkDay(state.bm.id, id);
    },

    async [BM_ADD_DAY_OFF]({state}) {
        return BMService.addDayOff(state.bm.id, {startDate: state.dayOff.startDate, endDate: state.dayOff.endDate});
    },
    async [BM_DELETE_DAY_OFF]({state}, id) {
        return BMService.deleteDayOff(state.bm.id, id);
    },

    [BM_ACTIVE](_, id) {
        return BMService.active(id)
    },
    [BM_INACTIVE](_, id) {
        return BMService.inactive(id)
    },
    [BM_DELETE]({state}) {
        return BMService.delete(state.bm.id)
    },
    [BM_RESET_STATE]({commit}) {
        commit(BM_RESET_STATE)
    }
}
export default {
    state,
    actions,
    mutations,
    getters
}
